/**
 * Internal layer types used for frontend feature styling.
 * These represent the visual layer types applied to GeoJSON features.
 */
export enum GeoLayerType {
  /** Partner availability layer - shows availability metrics */
  AVAILABILITY = "availability",
  /** Customer demand layer - shows demand heatmap */
  DEMAND = "demand",
  /** Entity boundary layer - shows entity boundaries (stroke only, no fill) */
  BOUNDARY = "boundary",
}
